import { render, staticRenderFns } from "./export-button.vue?vue&type=template&id=3bac0afb&"
import script from "./export-button.vue?vue&type=script&lang=js&"
export * from "./export-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports